<script setup>
import {useStore} from "vue2-helpers/vuex";
import Avatar from "@/components/ui/Avatar.vue";
import UserEdit from "@/components/team/UserEdit.vue";
import Vue, {ref, inject} from "vue";
import teamService from "@/services/team.service";

defineProps(['users', 'type']);

const store = useStore();

const getUsersList = inject('getUsersList');
const editUser = ref(null);

async function deleteUser(id) {
    if (!confirm("Remove user?")) return;

    await teamService.deleteUser(id);
    getUsersList();
}

async function sendActivationEmail(id) {
    const {data} = await teamService.sendActivationEmail(id);

    Vue.notify({
        group: 'app',
        type: data ? 'success' : 'error',
        duration: 5000,
        text: data ? 'Email sent' : 'Error occurred while sending message'
    })
}
</script>

<template>
    <div class="main-inner__content">
        <ul class="list-contacts list-contacts--full">
            <li v-for="user in users" :key="user.id">
                <div class="card card--bordered card--centered">
                    <Dropdown
                        v-if="
                            (store.getters.isEnterprise && (type !== 'admin' || (store.getters.permissions.includes('team-manage') && !user.is_proxy_admin)))
                            || store.getters.isEcosystem
                            || store.getters.isStartup
                        "
                        class="dropdown-original dropdown-incard icons-list dropdown-small ml-auto"
                    >
                        <DropdownItem
                            class="icons-list__edit"
                            @click="editUser.open(user.id)"
                        >
                            Edit User
                        </DropdownItem>

                        <DropdownItem
                            v-if="
                                !user.is_main_admin && (
                                    (store.getters.isEnterprise && store.getters.permissions.includes('team-manage'))
                                    || store.getters.isEcosystem
                                    || store.getters.isStartup
                                )
                            "
                            class="icons-list__delete"
                            @click="deleteUser(user.id)"
                        >
                            Remove User
                        </DropdownItem>

                        <DropdownItem
                            v-if="!user.confirmed"
                            class="icons-list__invite"
                            @click="sendActivationEmail(user.id)"
                        >
                            Re-send Invite
                        </DropdownItem>
                    </Dropdown>

                    <div class="image-block image-block--rounded--lg">
                        <Avatar
                            :username="user.name"
                            :src="user.avatar"
                            :size="75"
                        />
                    </div>

                    <h5 class="heading5">{{ user.name }}</h5>
                    <p>{{ user.job_title }}</p>
                </div>
            </li>
        </ul>

        <UserEdit
            ref="editUser"
            @saved="getUsersList"
        />
    </div>
</template>

<style scoped>

</style>
